module.exports = __webpack_public_path__ + "static/media/karajan_dashboard_web_mobile_background.8b883f5c.jpg";